import { render, staticRenderFns } from "./ChoosePaymentMethodDialog.vue?vue&type=template&id=44ba4f54&scoped=true"
import script from "./ChoosePaymentMethodDialog.vue?vue&type=script&lang=js"
export * from "./ChoosePaymentMethodDialog.vue?vue&type=script&lang=js"
import style0 from "./ChoosePaymentMethodDialog.vue?vue&type=style&index=0&id=44ba4f54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ba4f54",
  null
  
)

export default component.exports